import type { BreBFaultModeSchema } from '@paguz/contracts';
import type { z } from 'zod';

export type FaultMode = z.infer<typeof BreBFaultModeSchema>;

/** Modos del simulador Bre-B (`07-integraciones-externas.md` §11) explicados para el operador. */
export const FAULT_MODES: Readonly<Record<FaultMode, { label: string; effect: string }>> = {
  NORMAL: { label: 'Normal', effect: 'Bre-B confirma en 1–3 s. La compra se completa.' },
  REJECT: {
    label: 'Rechazo del comercio',
    effect: 'La entidad del comercio rechaza: la saga libera el cupo y la compra queda fallida.',
  },
  TIMEOUT: {
    label: 'Timeout Bre-B',
    effect:
      'Sin callback en 20 s: la compra queda "en verificación" y se resuelve sola por consulta.',
  },
  LATE_CALLBACK: {
    label: 'Callback tardío',
    effect:
      'El callback llega a los ~25 s, después del SLA: pasa por verificación y luego se completa.',
  },
  DUPLICATE_CALLBACK: {
    label: 'Callback duplicado',
    effect: 'Bre-B envía el callback dos veces: se procesa una sola vez (idempotencia).',
  },
};

export const FAULT_MODE_ORDER: readonly FaultMode[] = [
  'NORMAL',
  'REJECT',
  'TIMEOUT',
  'LATE_CALLBACK',
  'DUPLICATE_CALLBACK',
];
